import React, { useState } from 'react'
import styles from './MicrositeDnsInstructionsCard.module.css'
import { Copy, Check, Info } from 'lucide-react'

/**
 * MicrositeDnsInstructionsCard
 * Shown after micrositeAddDomain returns dnsInstructions — displays
 * the TXT record type/name/value with one-click copy buttons so
 * the salon owner can paste them into their domain registrar.
 *
 * Usage:
 *   <MicrositeDnsInstructionsCard
 *     instructions={{ type: 'TXT', name: '_lokaci-verify.glamstudio.in', value: 'lokaci-verify-a1b2c3d4' }}
 *   />
 */
const CopyField = ({ label, value }) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
            setTimeout(() => setCopied(false), 1800)
        } catch {
            // clipboard unavailable — silently ignore
        }
    }

    return (
        <div className={styles.row}>
            <span className={styles.rowLabel}>{label}</span>
            <div className={styles.valueWrap}>
                <code className={styles.value}>{value}</code>
                <button type="button" className={styles.copyBtn} onClick={handleCopy}>
                    {copied ? <Check size={13} /> : <Copy size={13} />}
                </button>
            </div>
        </div>
    )
}

const MicrositeDnsInstructionsCard = ({ instructions }) => {
    if (!instructions) return null

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <Info size={15} className={styles.infoIcon} />
                <span>Add this DNS record to verify ownership</span>
            </div>

            <CopyField label="Type" value={instructions.type} />
            <CopyField label="Name" value={instructions.name} />
            <CopyField label="Value" value={instructions.value} />

            <p className={styles.note}>
                It can take a few minutes to a few hours for DNS changes to propagate.
                Once added, come back and click Verify.
            </p>
        </div>
    )
}

export default MicrositeDnsInstructionsCard